import {EntityType} from '../../../../constants/EntityTypes';
import {PersonalMenuField} from '../stores/PersonalMenuFIeld';
import {newMenuExec, deleteItemMessage, deleteFolderMessage} from '../constants/constants';
import {getUuid4} from '../../../../utils/getUuid4';
import {showConfirmMessage} from '../../../../_shared/Messages/actions/MessageActions';
import {getMessageByKey} from '../../../../services/msgService';
import {extractSqlMsg} from '../../../../Localization/texts';
import messagesText from '../../../../_shared/Messages/texts';
import * as fieldTypes from '../../../../constants/FieldTypes';

export function addToMenu(sourceField) {
    const newField = new PersonalMenuField({exec: newMenuExec, type: EntityType.MENU}, sourceField);
    const fieldAddedTo =
        sourceField.type === fieldTypes.TAB ? sourceField : sourceField.parentField;
    const collection = fieldAddedTo.collection;

    const {screen} = newField;

    newField.title = screen.newTitle;
    newField.name = getUuid4();
    newField.parentField = fieldAddedTo;

    collection.addField(newField);
    collection.setExpanded(true);

    screen.setActive(newField);
    screen.setSelected(newField);
    newField.setChanging(true);
}

export function removeFromMenu(field) {
    const message = field.type === fieldTypes.TAB ? deleteFolderMessage : deleteItemMessage;
    const {entity, key} = message;

    getMessageByKey(entity, key, field.title).then(res => {
        const msg = extractSqlMsg(res);
        const props = {
            title: msg,
            confirmButtonText: messagesText.accept,
            cancleButtonText: messagesText.cancel,
            defaultButton: 0,
            onConfirm: () => {
                deleteField(field);
            }
        };
        showConfirmMessage(props);
    });
}

export function deleteField(field) {
    field.parentField.collection.deleteField(field);
    field.screen.setActive(false);
}
